import { Link } from "react-router-dom";

export default function MobileTabBar() {
  const items = [
    { to: "/", icon: "ri-home-5-line", label: "首页" },
    { to: "/category/synopsis", icon: "ri-book-open-line", label: "剧情" },
    { to: "/category/cast", icon: "ri-user-star-line", label: "主演" },
    { to: "/search", icon: "ri-search-line", label: "搜索" },
  ];

  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
      <div className="flex items-stretch justify-around">
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="flex flex-1 flex-col items-center gap-1 py-2.5 text-foreground-500 transition-colors hover:text-primary-700"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className={`${item.icon} text-xl leading-none`}></i>
            </span>
            <span className="font-label text-[11px] leading-none">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}